import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { CurrencyNetworkIcon } from '@root/entities/currency/ui'
import { Deeplink, DeeplinkURL } from '@root/entities/deeplinking'
import { selectedNetworkAtom } from '@root/entities/network'
import { InviteCode, type ReferralCode } from '@root/entities/referral'
import { useTranslation } from '@root/shared/localization'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  referralCode: ReferralCode
  withLabel?: boolean
  withLink?: boolean
} & ClassNameProps

export const ReferralCodeInfo = ({
  referralCode,
  withLabel,
  withLink,
  className,
}: Props) => {
  const { t } = useTranslation()
  const [network] = useAtom(selectedNetworkAtom)

  const referralLink = DeeplinkURL.fromDeeplink(
    new Deeplink.InviteCodeJoin({ inviteCode: InviteCode(referralCode) }),
  )

  return (
    <Root className={className}>
      {withLabel ? (
        <Label>{t('referral.code-info.current-code-label')}</Label>
      ) : undefined}
      <Code>
        <CurrencyNetworkIcon network={network} size={25} />
        {referralCode.toString()}
      </Code>
      {withLink ? <Link>{referralLink.toString()}</Link> : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  text-align: center;
  justify-content: center;
  gap: 5px;
`

const Label = styled.div`
  color: var(--textA-11);
  text-align: center;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`

const Code = styled.div`
  color: var(--text-12);
  text-align: center;

  display: grid;
  grid-auto-flow: column;
  gap: 4px;

  font-size: 24px;
  font-weight: 700;

  justify-content: center;
  align-content: center;
  align-items: center;
`

const Link = styled.div`
  color: var(--textA-9);
  text-align: center;

  font-size: 12px;
  font-weight: 400;
  margin-top: 4px;
`
